import { PageHeader } from '@/shared/layouts/PageHeader';
import { useUser } from '@/shared/hooks/useAuth';
import { registerAdminWidgets } from '../widgets/admin/register';
import { registerSuperAdminWidgets } from '../widgets/superadmin/register';
import { registerSharedWidgets } from '../widgets/shared/registerSharedWidgets';
import { superAdminLayout } from '../widgets/superadmin/superAdminLayout';
import { DashboardLayoutEngine } from '../infrastructure/layout/DashboardLayoutEngine';
import { DashboardProvider } from '../infrastructure/hooks/DashboardProvider';

export function SuperAdminDashboard() {
  const user = useUser();

  // Register both SuperAdmin specific widgets and standard Admin widgets 
  // since the SuperAdmin layout reuses Admin widgets.
  registerAdminWidgets();
  registerSuperAdminWidgets();
  registerSharedWidgets();

  return (
    <DashboardProvider>
      <div className="flex flex-col gap-6">
        <PageHeader
          title={`Welcome, ${user?.displayName ?? 'Owner'}`}
          description="Here's what's happening today."
          breadcrumbs={[
            { label: 'Home', to: '/' },
            { label: 'Owner Dashboard' }
          ]}
        />
        
        <DashboardLayoutEngine layout={superAdminLayout} />
      </div>
    </DashboardProvider>
  );
}
